/**
 * Frontend-only Support Ticket types/constants.
 * Backend contract will later mirror these shapes.
 */

export const SUPPORT_TICKET_STATUS = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
}

export const SUPPORT_TICKET_STATUSES = [
  SUPPORT_TICKET_STATUS.OPEN,
  SUPPORT_TICKET_STATUS.IN_PROGRESS,
  SUPPORT_TICKET_STATUS.CLOSED,
]

export const SUPPORT_TICKET_CATEGORY_OPTIONS = [
  { value: 'ISSUE', label: 'Issue' },
  // { value: 'PROBLEM', label: 'Problem' },
  { value: 'QUESTION', label: 'Question' },
  { value: 'SUGGESTION', label: 'Suggestion' },
  { value: 'FEATURE_REQUEST', label: 'Feature Request' },
]

export const SUPPORT_TICKET_PRIORITY_OPTIONS = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
]

export const INITIAL_TICKET_FORM = {
  subject: '',
  description: '',
  category: 'ISSUE',
  priority: 'MEDIUM',
}
